import React from 'react';

import { Content } from './Content.js';
import NavigationArrow from './NavigationArrow.jsx';
import NrgComponent from './../NrgComponent.jsx';
import $ from 'jquery'; 
import { ReactComponent as CloseIcon } from '../../icons/svg/close.svg';

export default class PeoplePopup extends NrgComponent {

  constructor(props) {
    super(props);

    this._onKeydown = this._onKeydown.bind(this);
    this._body = null;
  }

  componentDidMount() {
    $(document.body).on('keydown', this._onKeydown);
    this._body = $(document.body);
  }

  componentWillUnmount() {
    $(document.body).off('keydown', this._onKeydown);
    this._body = null;
  }

  render() {
    const person = this.props.person;
    const displayClass = (this.props.open === false) ? 'hidden' : '';
    const pictureUrl = (person.pictureUrl === '')
      ? '../../assets/img/avatar-gray-popup.jpg'
      : person.pictureUrl
    ;

    this._setBodyFullscreenState();

    return (
      <React.Fragment>
        {person &&
        <div className={`PeoplePopup ${displayClass} mask`} onClick={(event) => this.props.actions.closeViaMask(event)}>
          <div className="container-fluid inner">
            <div className="row top">
              <div className="col-xs-16">
                <h3 className="top-title hidden-md-up">{Content.people.popup.titles.top}</h3>
                <div className="close" onClick={() => this.props.actions.close()}>
                  <CloseIcon viewBox="0 0 93.7 93.7"></CloseIcon>
                </div>
              </div>
            </div>
            <div className="row hidden-lg-up">
              <div className="col-xs-16">
                <div className="image-container">
                  <div style={ { backgroundImage: `url('${pictureUrl}')` } }/>
                </div>
              </div>
            </div>
            <div className="row middle">
              <div className="hidden-md-down col-md-5">
                <div className="image-container">
                  <div style={ { backgroundImage: `url('${pictureUrl}')` } }/>
                </div>
              </div>
              <div className="col-xs-16 col-sm-10 col-md-7 main-content">
                <div className="col-sm-16 hidden-sm-down">
                  <h3 className="top-title">{Content.people.popup.titles.top}</h3>
                </div>
                <div className="col-xs-16 name">
                  <h3>{person.name}</h3>
                </div>
                <div className="col-xs-16 job-title">
                  <h4>{person.jobTitle}</h4>
                </div>
                <div className="col-xs-16 favourites person-favorites  hidden-md-up">
                  <div className="col-xs-16">
                    <h3 className="top-title">{Content.people.popup.titles.favourites}</h3>
                  </div>
                  {
                    person.favourites && person.favourites.map((favourite, index) => {
                      var borderClass = (index === (person.favourites.length - 1)) ? 'border-block' : '';

                      return (
                        <div className={`col-xs-16 ${borderClass}`} key={index}>
                          <h4>{favourite.subject}</h4>
                          <p>{favourite.answer}</p>
                        </div>
                      );
                    })
                  }
                </div>
                <div className="col-xs-16 bio">
                  <p>{person.bio}</p>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 sidebar person-favorites hidden-sm-down">
                <div className="col-xs-16">
                  <h3 className="top-title">{Content.people.popup.titles.favourites}</h3>
                </div>
                {
                  person.favourites && person.favourites.map((favourite, index) => {
                    var borderClass = (index === (person.favourites.length - 1)) ? 'border-block' : '';

                    return (
                      <div className={`col-xs-16 ${borderClass}`} key={index}>
                        <h4>{favourite.subject}</h4>
                        <p>{favourite.answer}</p>
                      </div>
                    );
                  })
                }
              </div>
            </div>
            <div className="row navigation">
              <div className="col-xs-8 nav-left">
                <NavigationArrow direction="left" actions={this.props.actions} showing={this.props.canNavigateLeft} />
              </div>
              <div className="col-xs-8 nav-right">
                <NavigationArrow direction="right" actions={this.props.actions} showing={this.props.canNavigateRight} />
              </div>
            </div>
          </div>
        </div>}
      </React.Fragment>
    );
  }

  _onKeydown(event) {
    if (this.props.open !== true) {
      return;
    }

    switch (event.keyCode) {
      case 37: // left arrow
        if (this.props.canNavigateLeft) {
          this.props.actions.navigateLeft();
        }
        break;
      case 39: // right arrow
        if (this.props.canNavigateRight) {
          this.props.actions.navigateRight();
        }
        break;
      case 27: // esc
        this.props.actions.close();
        break;
    }
  }

  _setBodyFullscreenState() {
    if (this._body === null) {
      return;
    }

    if (this.props.open !== true) {
      this._body.removeClass('fullscreen');
      return;
    }

    this._body.addClass('fullscreen');
  }

};
